export default __webpack_public_path__ + "static/media/cairns-logo-processing.66ae6512.png";